import { inject, Injectable } from '@angular/core';
import { CanActivateFn, CanDeactivateFn, NavigationCancel, Router } from '@angular/router';

import { select, Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import * as ReportingActions from '@reporting/reporting.actions';
import * as fromReporting from '@reporting/reporting.reducers';

import { StrategyComponent } from '@strategy/strategy.component';

@Injectable()
export class SurveyGuardService {
  protected readonly onDestroy$: Subject<void> = new Subject();
  canExitSurvey: boolean;
  step: number;
  intendedPath = '/reports/dashboard';

  constructor(
    private store: Store,
    private router: Router
  ) {
    this.store.select(fromReporting.selectSuperhuman).subscribe((value) => {
      this.canExitSurvey = value.canExitSurvey;

      if (this.canExitSurvey) {
        void this.router.navigate([this.intendedPath]);
      }
    });
  }

  canDeactivate(): boolean {
    this.router.events.pipe(filter((event) => event instanceof NavigationCancel)).subscribe((el) => {
      this.intendedPath = el ? el['url'] : '/reports/dashboard';
    });

    if (this.canExitSurvey === undefined) {
      this.store.dispatch(ReportingActions.updateSuperhumanExitSurvey({ value: false }));
      this.store.dispatch(ReportingActions.showSuperhumanExitModal({ show: true }));
      return false;
    }

    if (this.canExitSurvey === false) {
      this.store.dispatch(ReportingActions.showSuperhumanExitModal({ show: true }));
      return false;
    }

    this.store.dispatch(ReportingActions.updateSuperhumanExitSurvey({ value: undefined }));
    return true;
  }

  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    return new Observable<boolean>((observer) => {
      this.store.pipe(select(fromReporting.selectSuperhumanNotification), takeUntil(this.onDestroy$)).subscribe((notification) => {
        if (!notification || !notification.length) {
          void this.router.navigate(['/reports/dashboard']);
        }
        observer.next(!!notification.length);
        this.onDestroy$.next();
        this.onDestroy$.complete();
      });
    });
  }
}

export const SurveyGuard: CanActivateFn = () => {
  return inject(SurveyGuardService).canActivate();
};

export const SurveyDeactivateGuard: CanDeactivateFn<StrategyComponent> = () => {
  return inject(SurveyGuardService).canDeactivate();
};
